import { Navigate } from 'react-router-dom';
import { isLoggedIn } from '../../helpers';

const PrivateRoute = ({ children }) => {
  const auth = isLoggedIn();
  return auth ? children : <Navigate replace to="/login" />;
};

export default PrivateRoute;
